import { Variable } from '@ff-scene-plugins/gift-shared/Variable';
import { photoToFfCanvas } from '@gift-variable-plugins/photo-shared/photoToFfCanvas';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { PhotoVariableOptions } from '@gift-variable-plugins/photo-shared/PhotoVariableOptions';
import { PhotoInputControl } from './PhotoInputControl';
import { photoHandler } from './private-assets/photoHandler';

export const photoPdpPlugin: Variable.Plugin<PhotoVariableOptions, PhotoVariableInput> = {
    pluginId: 'photo',
    InputControl: PhotoInputControl,
    toFfCanvas: photoToFfCanvas,
    privateUploadHandler: photoHandler
};